// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_235Hj0R_","dongleText":"dongleText_1a8ft-os","wxCode":"wxCode_7raeSo5p"};